export const IngredientModificationsTypes = {
  Bases: 'bases' as const,
  Bread: 'bread' as const,
  Dressings: 'dressings' as const,
  Premiums: 'premiums' as const,
  Toppings: 'toppings' as const,
};

export type IngredientModificationType =
  (typeof IngredientModificationsTypes)[keyof typeof IngredientModificationsTypes];
